module.exports = __webpack_public_path__ + "static/media/Opening-top.ff222d5f.png";